




























import Vue, { PropType } from 'vue'

import DocumentoViewer from './documento-view.vue'

import { Documento } from "../../../../store/livro-digital/documentos-repository"
import { Livro } from '../../../../store/livro-digital/livros-repository'

import ComentariosViewer from './comentarios-viewer.vue'

export type Data = {
    documento_selecionado: Documento | null
    reverse: boolean
    showLista: boolean
    show_comentarios: boolean
}

export default Vue.extend({
    props: {
        documentos: {
            type: Array as PropType<Documento[]>,
            required: true
        },
        codigo_condominio: {
            type: Number,
            required: true
        },
        livro: {
            type: Object as PropType<Livro>,
            required: true
        },
    },
    components: {
        DocumentoViewer,
        ComentariosViewer
    },
    data(): Data {
        return {
            documento_selecionado: null,
            reverse: false,
            showLista: true,
            show_comentarios: false
        }
    },
    computed: {
        controle_acesso() {
            return this.$store.getters.controleAcesso;
        },
        show_aprovacao() {
            /* @ts-ignore */
            return this.controle_acesso.livroDigital?.aprovacao || false
        }
    },
    methods: {
        close() {
            this.$emit('close')
        },
        next() {

            if (this.show_comentarios) {
                return
            }
            
            if (!this.documento_selecionado) {
                let [documento] = this.documentos
                this.documento_selecionado = documento
                
                return
            }

            let index = this.documentos.findIndex(d => d.IdDocsprime == this.documento_selecionado?.IdDocsprime)
            let next = index + 1;
            if (this.documentos.length <= next) {
                this.show_comentarios = true
                this.documento_selecionado = null
                this.reverse = false
                return
            }
            this.reverse = false
            let documento = this.documentos[next]
            this.documento_selecionado = documento
            
        },
        prev() {

            if (this.show_comentarios) {
                let documento = this.documentos[this.documentos.length - 1]
                this.reverse = true
                this.documento_selecionado = documento
                return
            }
            
            if (!this.documento_selecionado) {
                let [documento] = this.documentos
                this.documento_selecionado = documento
                
                return
            }

            let index = this.documentos.findIndex(d => d.IdDocsprime == this.documento_selecionado?.IdDocsprime)
            let next = index - 1;
            if (next < 0) {                
                return
            }
            this.reverse = true;
            let documento = this.documentos[next]
            this.documento_selecionado = documento
            
        },
        selectDocumentByIdDocumento(IdDocumento: number) {
            
            let document = this.documentos.find(documento => {
                return documento.IdDocumento === IdDocumento
            })
            
            if (document) {
                this.selectDocument(document)
            }
        },
        selectDocument(documento: Documento) {
            this.reverse = false
            this.documento_selecionado = documento
            this.showLista = false
            this.show_comentarios = false
        },
        showComentarios() {
            this.show_comentarios = true
            this.documento_selecionado = null
            this.reverse = false
            this.showLista = false
        }
    },
    watch: {
        documentos: {
            deep: true,
            immediate: true,
            handler() {
                if (this.documento_selecionado === null) {
                    let [documento] = this.documentos
                    this.reverse = false
                    this.documento_selecionado = documento
                }
            }
        },
    }
})

